import VoucherUsed from './VoucherUsed';

export default VoucherUsed;


// WEBPACK FOOTER //
// ./src/modules/VoucherUsed/index.tsx